var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmtpServerExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 25.846,
    y1: 25.846,
    x2: 44.929,
    x1: 9.25,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ab40",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4a73c",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ed992f",
    offset: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2861d",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 44.356,
    y1: 6.948,
    x2: 26.58,
    x1: 5.988,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eba84b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d97218",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m9 26 36-14.308V38a2 2 0 0 1-2 2H9Z",
    style: {
      fill: "url(#a)"
    },
    transform: "translate(5.714 7.821) scale(.7619)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M3 11.692V38a2 2 0 0 0 2 2h38a1.98 1.98 0 0 0 1.283-.478z",
    style: {
      fill: "url(#b)"
    },
    transform: "translate(5.714 7.821) scale(.7619)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.202h32v1.29L26.804 27.738a4.572 4.572 0 0 1-5.608 0L8 17.49Z",
    opacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.821h32v1.29L26.26 27.1a3.8 3.8 0 0 1-4.52 0L8 17.11Z",
    opacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fabb62",
    d: "M9.524 13.916h28.952c.842 0 1.524.682 1.524 1.524v1.29l-14.284 9.732a3.046 3.046 0 0 1-3.432 0L8 16.729V15.44c0-.842.682-1.524 1.524-1.524Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.35 17.497h8v11h-8z",
    style: {
      opacity: 1,
      fill: "#9e1212",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e1212",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m20.35 38.599-11-13.102h22Zm-4-27.102h8v4h-8z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#892ca0",
      fillOpacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M16.41 11.417h8v8.363h-8z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#892ca0",
      fillOpacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M16.41 17.417h8v11h-8z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#892ca0",
      fillOpacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m20.41 38.519-11-13.102h22Z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmtpServerExport);
export default __webpack_public_path__ + "static/media/smtpServerExport.7aad9bec7da9e53ba40b01a1dc7935e4.svg";
export { ForwardRef as ReactComponent };